import React, { Fragment, cloneElement } from 'react';

export function IconButton({ iconSrc, svgSrc }) {

    const SvgElement = (() => {
            if (!svgSrc) return null;
            if (React.isValidElement(svgSrc)) return cloneElement(svgSrc);
            if (typeof svgSrc === 'function') {
                const Cmp = svgSrc;
                return <Cmp />;
            }
    
            return null;
        })();

    return (
        <Fragment>
             <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
               <g filter="url(#filter0_d_9_53)">
                 <circle cx="22.5" cy="18.5" r="18.5" fill="white" />
               </g>
               <foreignObject x="4.5" y="0.5" width="37" height="37">
                <div xmlns="http://www.w3.org/1999/xhtml" style={{ color: 'black', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {iconSrc ? ( <img src={iconSrc} alt="" /> ) : SvgElement }
                </div>
              </foreignObject>
               <defs>
                 <filter id="filter0_d_9_53" x="0" y="0" width="45" height="45" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                   <feFlood flood-opacity="0" result="BackgroundImageFix" />
                   <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                   <feOffset dy="4" />
                   <feGaussianBlur stdDeviation="2" />
                   <feComposite in2="hardAlpha" operator="out" />
                   <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                   <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9_53" />
                   <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9_53" result="shape" />
                 </filter>
               </defs>
             </svg>
        </Fragment>
    );
}